import { Component, ViewContainerRef, inject, effect, PLATFORM_ID } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { ToastService } from './services/general/toast.service';
import { ThemeService } from './services/general/theme.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  private document = inject(DOCUMENT);
  private platformId = inject(PLATFORM_ID);
  private theme = inject(ThemeService);

  title = 'cytech360-management-web';

  constructor(vcRef: ViewContainerRef, toast: ToastService) {
    toast.registerViewContainerRef(vcRef);

    effect(() => {
      if (!isPlatformBrowser(this.platformId)) return;
      const html = this.document.documentElement;
      if (this.theme.isDark()) {
        html.classList.add('dark');
      } else {
        html.classList.remove('dark');
      }
    });
  }
}
